module.exports = __webpack_public_path__ + "img/purple.db8d71f1.png";